import styled from 'styled-components';

import { WITH_ID_SUFFIX } from 'components/insights/constants';
import { useProfile } from 'context/profile';
import useWebsocketExport from 'hooks/useWebsocketExport';
import { createAnalyticsExport } from 'services/api/insights/analytics';
import { getAnalyticsFilters, useInsightsStore } from 'stores/insightsStore';

import { AnalyticsQueryParams } from '../../query/useAnalyticsInfiniteQuery';

import Export from './Export';

type Props = {
  disabled?: boolean;
  filename?: string;
  show?: boolean;
  params: AnalyticsQueryParams;
};

function ApiExport({ disabled = false, filename, show = true, params }: Props) {
  const { profile } = useProfile();
  const { initiateExport, exporting } = useWebsocketExport(createAnalyticsExport);
  const filters = useInsightsStore((state) => getAnalyticsFilters(state, profile));

  const handleClick = () => {
    const exportParams = {
      ...params,
      dimensions: params.dimensions?.map((d) => d.replace(WITH_ID_SUFFIX, '')),
      filename,
    };
    initiateExport({ params: exportParams, filters });
  };

  return <StyledExport disabled={disabled} show={show} loading={exporting} onClick={handleClick} />;
}

export default ApiExport;

const StyledExport = styled(Export)`
  margin-left: auto;
`;
